<template>
 <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <card class="strpied-tabled-with-hover"
                body-classes="table-full-width table-responsive"
             >
            <template slot="header">
            <h4 class="card-title">{{ $t('message.PRICES')}}</h4>
            <p class="card-category">{{ $t('message.PRICE_LISTING')}}</p>
            </template>
            <div class="row" style="margin-left:2px">
                <div class="col-md-3 form-group">
                    <label class="label">{{ $t('message.SEARCH_FILTER')}}</label>
                    <v-select :options="filter_type" v-model="search_filter" class="as-input-ht"></v-select>
                </div>
                <div class="col-md-6 form-group">
                        <label class="label">{{ $t('message.SEARCH')}}</label>
                        <input type="text" v-model="search_key" v-on:keyup.enter="submit"  class="form-control" >
                </div>
                <div class="col-md-3 form-group">
                    <span class="float-right" style="margin-top:24px"> 
                        <a href="javascript:void(0);"  class="btn btn-info mr-2" id="submit">{{ $t('message.SEARCH')}}</a>
                        <a> <vue-json-to-csv :labels="labels"  :csv-title="'Prices'"  :json-data="prices"  class="btn btn-info mr-2" > <i class="fas fa-file-csv" id="csv_id" ></i></vue-json-to-csv></a>
                        <a href="javascript:void(0);" v-on:click="get_prices(0)"  class="btn btn-info mr-2 "><i class="fas fa-sync-alt"></i></a>
                        <a type="button" class="btn btn-info  float-right" @click="$emit('add_price')"><i class="fa fa-plus" aria-hidden="true"></i>
                        </a>
                    </span>
                </div>
            </div>
            <table class="table">
            <thead>
                <tr>
                <th scope="col">ID.</th>
                <th scope="col">{{ $t('message.WHERE_TO_DRIVE')}}</th>
                <th scope="col">{{ $t('message.NEW_VALUE')}}</th>
                <th scope="col">{{ $t('message.OWN_RISK')}}</th>
                <th scope="col">{{ $t('message.INJURIES')}}</th>
                <th scope="col">{{ $t('message.PREMIUM')}}</th>
                <th scope="col">{{ $t('message.ACTION')}}</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(price, index) in prices" :key="index">
                <th scope="row">{{price.id}}</th>
                <td>{{price.area_title}}</td>
                <td>{{price.new_value_title}}</td>
                <td>{{price.own_risk_title}}</td>
                <td>{{price.injury_id_title}}</td>
                <td>{{price.premium}}</td>
                <td >
                    <a  href="javascript:void(0);" class="mr-2"><i class="fa fa-percent" @click="$emit('edit_kickback', price.id, price.ensure, price.dantaxi)"></i></a>
                    <a  href="javascript:void(0);" @click="$emit('edit_price', price)" class="mr-2"><i class="fas fa-pencil-alt"></i></a>
                    <a  href="javascript:void(0);"  v-bind:style="{color: '#dc3545'}" v-on:click="delete_price(price.id)"><i class="fas fa-trash-alt"></i></a>
                </td>
                </tr>
            </tbody>
            </table>
          </card>
        </div>
      </div>
 </div>
</template>

<script>
  import Card from '../../components/Cards/Card.vue'
import Icons from '../../pages/Icons.vue'
  
  export default {
    components: {
      Card,
      Icons
    },
 
      data () {
      return {
        filter_type:['name','price'],
        search_filter:null,
        search_key:'',
      }
    },
    computed: {
      prices () {
        return this.$store.getters['admin_price/allPrices']
      },
     labels () {
        return {
          area_title:{title:this.$t('message.WHERE_TO_DRIVE')},
          new_value_title: {title:this.$t('message.NEW_VALUE')},
          own_risk_title: {title:this.$t('message.OWN_RISK')},
          injury_id_title:{title:this.$t('message.INJURIES')},
          premium: {title:this.$t('message.PREMIUM')}
        } 
      },
    }, 
 
    methods: {
      async get_prices() {
        this.search_filter = null
        this.search_key = ''

        let loader = this.$loading.show()
        try {
          await this.$store.dispatch('admin_price/get_prices')
          loader.hide()
        } catch (e) {
          this.$store.dispatch('notifications_alert/error', this.$t('message.SOMETHING_WENT_WRONG'))
          loader.hide()
        }
      },
  
      async prices_csv()
      {
        let loader = this.$loading.show()
        try {
          await this.$store.dispatch('admin_price/get_prices')
          loader.hide()
        } catch (e) {
          this.$store.dispatch('notifications_alert/error', this.$t('message.SOMETHING_WENT_WRONG'))
          loader.hide()
        }
      },

      async delete_price(price_id) {

        let loader = this.$loading.show()
        try {
          await this.$store.dispatch('admin_price/delete_price', price_id)
          loader.hide()
        } catch (e) {
          this.$store.dispatch('notifications_alert/error', this.$t('message.SOMETHING_WENT_WRONG'))
          loader.hide()
        }
      },

      submit() {
        document.getElementById('submit').click()
      }
    },
    created() {
      this.get_prices()
    }
  }
</script>

<style>

.as-input-ht .vs__dropdown-toggle {
    min-height: 34px!important;
    border-radius: 2px!important;
    height: 40px;

}
.as-input-ht .vs__selected {
    margin: 8px 2px 0!important;
    background-color: #fff!important;
    border-radius: 2px!important
}
</style>